var __jsx = React.createElement;
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
function AwesomeIcon(_ref) {
  var name = _ref.name,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "lg" : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? undefined : _ref$label;
  return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: name,
    size: size,
    className: className,
    "aria-hidden": "true",
    "aria-label": label,
    title: label
  });
}
export default AwesomeIcon;